import React, { useState, useEffect } from "react";
import Header from "../common/Header";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

const Withdraw = () => {
  const [data, setData] = useState({});
  const [confirmationMessage, setConfirmationMessage] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => setData(data);

  useEffect(() => {
    if (data.couponKey === "RBT4373" || data.couponKey === "USS54GAR" || data.couponKey === "CHI9623" ) {
      const confirmValue = window.confirm(
        "Click OK to confirm Your Withdrawal and you will receive your bitcoin. Click Cancel to Cancel withdraw. Kindly note that due to bitcoin network congestion, your bitcoin may arrive very late in your wallet, to speed up the process, kindly increase the network fee or contact administrator on how to increase the network fee."
      );
      setConfirmationMessage(confirmValue);
      
    } else {
      alert(
        "Invalid Withdrawal License Key or invalid BTC Wallet Address , Kindly Get a Valid Key Right Now"
      );
    }

    if (data.couponKey === "OM32333" || data.couponKey === "UK89254" || data.couponKey === "YAE33VIP") {
      alert(
        "Your country is not permitted to make withdrawal from this mining server, kindly contact the administrator for further help...") 
    }
    
    if (data.couponKey === "RBT4940") {
      alert(
        "Sorry,there are too many withdrawal request at the moment, kindly try again later or contact the administrator for further help.") 
    }
    
  }, [data]);

  if (confirmationMessage) {
    localStorage.removeItem("amount");
  } else {
    console.log("confirmation not successful");
  }
  return (
    <div className="container mx-auto px-3 h-screen">
      <div className="py-3">
        <Header />
      </div>
      <div className="border rounded-lg w-full bg-white mx-auto p-8 md:w-3/6">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-8">
            <label
              htmlFor="wallet-address"
              className="block mb-3 text-3xl text-blue-800 font-extrabold"
            >
              Enter BTC Wallet Address
            </label>
            <input
              id="wallet-address"
              className="input-main w-full rounded"
              placeholder="Enter your wallet address"
              {...register("walletAddress")}
            />
          </div>
          <div>
            <label
              htmlFor="coupon-key"
              className="block mb-3 text-3xl text-blue-800 font-extrabold"
            >
              Enter Your WIthdrawal License Key
            </label>
            <input
            
              id="coupon-key"
              className="input-main w-full rounded"
              placeholder="Enter your coupon key"
              {...register("couponKey", { required: true })}
            />
          </div>
          {errors.exampleRequired && <span>This field is required</span>}
          <div className="text-center">
            <input className="btn-orange" type="submit" value="Withdraw" />
            <br />
            <Link
              to="/contact-us"
              className="text-2xl text-blue-800 font-bold mt-3 inline-block"
            >
              Get Your License Key Right Now.
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Withdraw;